import { Stack, Typography } from '@mui/material';
import { RotateScreenIcon } from './RotateScreenIcon';
import { refineFonts } from '@/Theming/refineFonts';
import { FC, useContext, useEffect, useState } from 'react';
import { useInvestigationDetails } from '@hooks/useInvestigationDetails';
import { LocalizationContext } from '@context/LocalizationContext';

export const RotateScreen: FC = () => {
	const [userName, setUserName] = useState<string>('');
	const investigationDetails = useInvestigationDetails();
	const { RotateScreen } = useContext(LocalizationContext);

	useEffect(() => {
		if (investigationDetails && !userName) {
			const customerName = investigationDetails?.account?.customerName?.split(' ')[0].toLocaleLowerCase();
			const capitalisedName = customerName?.charAt(0)?.toUpperCase() + customerName?.slice(1);
			setUserName(capitalisedName);
		}
	}, [investigationDetails]);

	return (
		<Stack height={'100%'} gap={'24px'} justifyContent={'center'} alignItems={'center'}>
			<RotateScreenIcon />
			<Stack gap={'4px'} justifyContent={'center'} alignItems={'center'}>
				{Boolean(userName) && (
					<Typography sx={{ ...refineFonts.largeBold }}>
						{RotateScreen.Title.replace('%1$s', userName)}
					</Typography>
				)}

				<Typography color={'textSecondary'} sx={{ ...refineFonts.mediumRegular }} textAlign={'center'}>
					{RotateScreen.Message}
				</Typography>
			</Stack>
		</Stack>
	);
};
